module.exports = __webpack_public_path__ + "static/media/17230012-KqD0wSgs.cb1b82d1.JPG";